import styled from 'styled-components'

import theme from '../../../theme/content'

export const FormContainer = styled.div`
	margin: 0 !important;
	overflow: hidden;
	width: 100%;
`